import { createContext, useContext } from 'react'

type DirectContactFormOrderAuthenticationHandler = () => void

export const DirectContactFormOrderAuthenticationContext = createContext<
  DirectContactFormOrderAuthenticationHandler | undefined
>(undefined)

export const useDirectContactFormOrderAuthenticationContext =
  (): DirectContactFormOrderAuthenticationHandler => {
    const context = useContext(DirectContactFormOrderAuthenticationContext)

    if (context === undefined) {
      throw new Error(
        'Direct contact form order authentication context is not available',
      )
    }

    return context
  }
